import { AdjustmentType } from 'views/ProFormaTable/constants';
import { IExpenseSummary, IIncomeSummary, IOperatingInfo } from 'views/ProFormaTable/types';
import { Format, RowValue } from '../../ExecutiveSummaryGenericTable/types';
import { AssumptionsMetricId } from '../../layout/metrics';
import { BlockResolver } from '../../layout/types';

const MONTHS_PER_YEAR = 12;

const cell = (value: string | number, format: Format) => (): RowValue => ({ value, format });

const adjustmentPercentage = (incomeSummary: IIncomeSummary, adjustmentType: AdjustmentType): string | number => {
    if (!Array.isArray(incomeSummary?.incomeAdjustments)) return '-';
    const matches = incomeSummary.incomeAdjustments.filter(candidate => candidate.adjustmentType === adjustmentType);
    return matches[matches.length - 1]?.percentOfIncome ?? '-';
};

export const proFormaAssumptionsResolver = (
    incomeSummary: IIncomeSummary,
    operatingInfo: IOperatingInfo,
    expenses: IExpenseSummary,
): BlockResolver<AssumptionsMetricId> => {
    const perYear = incomeSummary?.totalRentalIncome?.totalValuePerSfPerYear;

    return {
        hasData: () => true,

        effectiveRentPerSf: cell(perYear ? perYear / MONTHS_PER_YEAR : '-', 'currency-cents'),
        effectiveRentPerUnit: cell(incomeSummary?.totalRentalIncome?.totalPricePerUnit ?? '-', 'currency'),
        rentalIncomeGrowth: cell(operatingInfo?.rentalGrowthPercentage ?? '-', 'percentage'),
        expensesGrowth: cell(expenses?.totalOperatingExpenses?.totalAnnualGrowth ?? '-', 'percentage'),
        generalVacancy: cell(adjustmentPercentage(incomeSummary, AdjustmentType.GENERAL_VACANCY), 'percentage'),
        creditLoss: cell(adjustmentPercentage(incomeSummary, AdjustmentType.CREDIT_LOSS), 'percentage'),
    };
};
